import { InvoiceDocumentGenerationData } from '@mothership/document-types'
import { CreditSource } from '@mothership/finance/dist/api'

export const getDescriptionForCredit = (credit: InvoiceDocumentGenerationData['credits'][number]): string => {
  if (credit.source === CreditSource.MothershipCredit) {
    return 'Account credit'
  }
  return credit.description ?? 'No description provided.'
}
